import UserGuide from '../../views/UserGuide';

export default function UserGuidePage() {
  return <UserGuide />;
}
